export default {
    ADVANCE_SEARCH_FILTER: true,
    ADVANCE_SEARCH_ABORTION_SECTION: false,
}